// extracted by mini-css-extract-plugin
export default {"container":"qW-z","title":"rW-z","link":"sW-z"};